import React from 'react';
import useStore, { updateDeviceActivities, updateSelectedRecipient } from '../../Store/Store';
import { Avatar } from '@mui/material';

const RecipientsSelector = () => {
  const careRecipients = useStore((state) => state.careRecipients);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const width = useStore((state) => state.screenWidth);

  const handleSelector = (item) => {
    if (selectedRecipient !== item?._id) {
      updateSelectedRecipient(item?._id);
      updateDeviceActivities(null);
    } else {
      updateSelectedRecipient('');
      updateDeviceActivities(null);
    }
  };

  return (
    <div
      style={{
        paddingInline: '5px',
        display: 'flex',
        width: '96%',
        marginBlock: '-10px',
        justifyContent: 'end',
        marginTop: width > 550 ? '0px' : '15px',
      }}
    >
      {Object.values(careRecipients).map((item, idx) => (
        <Avatar
          key={idx}
          alt={item?.fullName}
          src={item?.imageUrl}
          style={{
            border: selectedRecipient !== item?._id ? '0.2px solid grey' : '3px solid #26786A',
            width: '50px',
            height: '50px',
            cursor: 'pointer',
            marginLeft: '8px',
          }}
          title={item?.email}
          onClick={() => handleSelector(item)}
        />
      ))}
    </div>
  );
};

export default RecipientsSelector;
